const InvoiceTypes = Object.freeze({
  InitialPayment: 'InitialPayment',
  MonthlyPayment: 'MonthlyPayment',
});

export default InvoiceTypes;
